import { Box, SimpleGrid } from '@chakra-ui/react'
import type { StatRowBlock } from '../../../types/reporting'
import { formatReportValue } from './reportFormat'
import { StatTile } from '../../shared/viz'

export function StatRowBlockView({ block }: { block: StatRowBlock }) {
  return (
    <Box className="report-block">
      <SimpleGrid columns={{ base: 2, md: Math.min(block.stats.length, 4) }} gap={4}>
        {block.stats.map((s) => (
          <StatTile key={s.label} label={s.label} value={formatReportValue(s.value, s.format)} context={s.context ?? undefined} />
        ))}
      </SimpleGrid>
    </Box>
  )
}
